import { createFileRoute } from '@tanstack/react-router';
import { SettingsForm } from '@/components/settings/SettingsForm';

export const Route = createFileRoute('/settings')({
  component: SettingsPage,
});

function SettingsPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-6 sm:py-8">
      <h1 className="mb-1 font-display text-2xl tracking-wider">Settings</h1>
      <p className="mb-6 text-sm text-muted">
        Saved on this device. Changes apply right away.
      </p>
      <SettingsForm />
    </div>
  );
}
